import { addLibraryFilter, removeLibraryFilter } from 'Pods/ThreeDStudio/Store/actions/filters'

export const getLibraryFilterUpdaterFunction = (value) => {
  return value ? addLibraryFilter : removeLibraryFilter
}
